var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center flex-col"},[(!_vm.isDashboardAccounts)?_c('empty-state',{attrs:{"size":_vm.compSize}}):_c('empty-state-3'),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }